import React from 'react'
import { AssistantIcon, CarIcon, DisabledIcon, KidsIcon, PassengerIconCyan, SeniorIcon } from '@/root/ui/shared'

export const getIcon = (code: string) => {
  switch (code) {
    case 'CAR':
    case '4WD':
      return <CarIcon color="primary-base" width={45} />
    case 'PAX003':
      return <SeniorIcon color="primary-base" />
    case 'PAX004':
      return <DisabledIcon color="primary-base" />
    case 'PAX005':
      return <AssistantIcon />
    case 'PAX006':
      return <KidsIcon color="primary-base" />
    default:
      return <PassengerIconCyan color="primary-base" width={22} />
  }
}
